function debounce(fn, wait) {
  let t;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function updateAllCheckerGrids() {
  const containers = document.querySelectorAll('.bh-checker-grid');
  if (!containers || containers.length === 0) return;

  containers.forEach(container => {
    const row1 = container.querySelector('.row-1');
    const row2 = container.querySelector('.row-2');
    if (!row1 || !row2) return;

    const baseSquareSize = parseFloat(container.dataset.squareSize) || 40;
    const containerWidth = Math.max(container.clientWidth, 1);
    const squaresNeeded = Math.max(1, Math.ceil(containerWidth / baseSquareSize));
    const adjustedSquareSize = containerWidth / squaresNeeded;

    container.style.setProperty('--adjusted-square-size', adjustedSquareSize + 'px');

    // Rebuild rows
    row1.innerHTML = '';
    row2.innerHTML = '';

    const computed = getComputedStyle(container);
    const bgColor = (computed.getPropertyValue('--bg-color') || '').trim() || '#EDE9E2';
    const gridColor = (computed.getPropertyValue('--grid-color') || '').trim() || '#353823';

    for (let i = 0; i < squaresNeeded; i++) {
      const isEven = i % 2 === 0;
      const square1 = document.createElement('div');
      square1.className = 'checker-square ' + (isEven ? 'bg' : 'grid');
      square1.style.width = adjustedSquareSize + 'px';
      square1.style.height = adjustedSquareSize + 'px';
      square1.style.backgroundColor = isEven ? bgColor : gridColor;
      row1.appendChild(square1);

      const square2 = document.createElement('div');
      square2.className = 'checker-square ' + (isEven ? 'grid' : 'bg');
      square2.style.width = adjustedSquareSize + 'px';
      square2.style.height = adjustedSquareSize + 'px';
      square2.style.backgroundColor = isEven ? gridColor : bgColor;
      row2.appendChild(square2);
    }
  });
}

const debouncedUpdate = debounce(updateAllCheckerGrids, 80);
window.addEventListener('resize', debouncedUpdate);
document.addEventListener('DOMContentLoaded', updateAllCheckerGrids);